import { now, toTimezone, parseISOToDateTime, toDateId } from '@calendly/datetime'

import { retrieveTimeNotation } from 'services/time_notation'
import { getMonthGetParam } from 'services/calendar'

const initialState = {
  timeNotation: {
    selected: null,
    stored: retrieveTimeNotation()
  },
  today: now().toISO(),
  initialMonthParam: getMonthGetParam(),
  monthShift: 0,
  spots: [],
  selectedSpots: [],
  selectedDaySpots: [],
  conflictCheckQueue: [],
  spotAutofocus: false,
  inviteePublisherError: false,
  bookingMethod: 'instant',
  showSpotSelectionError: false
}

export default (state = initialState, action) => {
  let queue
  let selectedSpots
  let selectedDayId
  let selectedStartTime
  let selectedDaySpots
  let selectedSpotIndex
  let selectedDaySpotsIndex
  let selectedSpotsByTimezone

  switch (action.type) {
    case 'SET_BOOKING_METHOD':
      return {
        ...state,
        bookingMethod: action.bookingMethod,
      }

    case 'SELECT_CALENDAR_DAY': {
      const normalizedDay = !action.day
        ? action.day
        : action.day.date != null
          ? { ...action.day, date: toDateId(action.day.date) }
          : { ...action.day }
      return {
        ...state,
        day: normalizedDay,
        spotAutofocus: Boolean(action.isFromKeyboard),
        spots: []
      }
    }

    case 'SELECT_SPOT_TIME':
      return {
        ...state,
        spots: [action.spot]
      }

    case 'ADD_SPOT_FROM_PARAMS':
      if (!action.spot) return state

      selectedSpots = Array.from(state.selectedSpots)
      selectedDaySpots = Array.from(state.selectedDaySpots)
      selectedStartTime = action.spot.start_time.split('T')
      selectedSpotIndex = selectedSpots.map((s) => s.start_time).indexOf(action.spot.start_time)

      if (selectedSpotIndex >= 0) return state

      selectedDaySpots.push(selectedStartTime[0])
      selectedSpots.push(action.spot)

      return {
        ...state,
        selectedSpots,
        selectedDaySpots,
        showSpotSelectionError: false
      }

    case 'ADD_OR_REMOVE_SPOT':
      if (!action.spot) return state
      selectedSpots = Array.from(state.selectedSpots)
      selectedDaySpots = Array.from(state.selectedDaySpots)
      selectedDayId = state.day.id

      selectedSpotIndex = selectedSpots.map((s) => s.start_time).indexOf(action.spot.start_time)
      if (selectedSpotIndex >= 0) {
        selectedDaySpotsIndex = selectedDaySpots.indexOf(selectedDayId)
        selectedDaySpots.splice(selectedDaySpotsIndex, 1)
        selectedSpots.splice(selectedSpotIndex, 1)
      } else {
        selectedDaySpots.push(selectedDayId)
        selectedSpots.push(action.spot)
      }
      return {
        ...state,
        selectedSpots,
        selectedDaySpots,
        showSpotSelectionError: false
      }

    case 'SPOT_SELECTION_ERROR':
      return {
        ...state,
        showSpotSelectionError: true
      }

    case 'UPDATE_SELECTED_SPOTS':
      selectedSpots = Array.from(state.selectedSpots)

      return {
        ...state,
        selectedSpots: Array.from(new Set([
          ...selectedSpots,
          ...action.spots
        ]))
      }

    case 'CLEAR_SPOTS':
      return {
        ...state,
        selectedSpots: [],
        selectedDaySpots: []
      }

    case 'SET_SELECTED_SPOTS':
      return {
        ...state,
        selectedSpots: action.spots
      }

    case 'ADD_TO_CHECK_QUEUE':
      queue = Array.from(state.conflictCheckQueue)
      queue.unshift(action.spot.start_time)
      return {
        ...state,
        conflictCheckQueue: queue
      }

    case 'REMOVE_FROM_CHECK_QUEUE':
      if (!action.spot) return state
      queue = Array.from(state.conflictCheckQueue)
      queue.splice(queue.indexOf(action.spot.start_time), 1)
      return {
        ...state,
        conflictCheckQueue: queue
      }

    case 'DESELECT_CALENDAR_DAY':
      return {
        ...state,
        day: null
      }

    case 'CHANGE_CALENDAR_MONTH':
      return {
        ...state,
        monthShift: state.monthShift + action.count
      }

    case 'CHANGE_TIME_NOTATION':
      return {
        ...state,
        timeNotation: {
          selected: action.notation,
          stored: action.notation
        }
      }
    case 'SET_INVITEE_PUBLISHER_ERROR':
      return {
        ...state,
        inviteePublisherError: true
      }

    case 'UPDATE_SELECTED_SPOTS_BY_TIMEZONE':
      selectedSpots = Array.from(state.selectedSpots)
      selectedSpotsByTimezone = selectedSpots.map((spot) => ({
        ...spot,
        start_time: toTimezone(parseISOToDateTime(spot.start_time), action.timezone).toISO({
          suppressMilliseconds: true
        })
      }))

      return {
        ...state,
        selectedSpots: selectedSpotsByTimezone
      }

    default:
      return state
  }
}
